<template>
  <div class='tpl-wrapper'>

    <div id="detailsToggle" v-show="showDetails">

      <button class="button button-only-icon praias-button"
        :class="{active: activeTab == 1}"
        @click="tabChange(1)"
        title="Map location"
      >
        <span class="icon-map-marker"></span>
      </button>

      <button class="button button-only-icon praias-button"
        :class="{active: activeTab == 2}"
        @click="tabChange(2)"
        title="Images from Google image search"
      >
        <span class="icon-camera"></span>
      </button>

      <button class="button button-only-icon praias-button"
        :class="{active: activeTab == 3}"
        @click="tabChange(3)"
        title="Map location"
      >
        <span class="icon-commenting"></span>
      </button>

    </div>

    <div id="map" v-show="activeTab == 1"></div>
    <div id="beach-images" v-show="activeTab == 2" class="max-height">
      <div id="images-wrapper">
        <div class='row'>
            <div v-for="image in activeBeach.images" class="col-md-4 col-sm-6 col-xs-12 img-box">
              <a :href="image.contextLink" target="_blank">
                <img :src="image.thumb" :title="image.title"/>
              </a>
            </div>
        </div>
        <div v-if="noResults" class="col-xs-12 details-header-space">
          <p>There are no relevant google images associated with this location.</p>
        </div>

      </div>
    </div>
    <div id="beach-comments" v-show="activeTab == 3" class="max-height">
      <div class="details-header-space container-medium">
        <h1 class="text-medium text-gray">{{ activeBeach.Name }}, {{ activeBeach.Locality }}</h1>
        <div>
          <p>Google search for <a target="_blank" :href="'https://www.google.com/search?q=' + activeBeach.Name">{{activeBeach.Name}}</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      showDetails: false,
      activeTab: 1,
      activeBeach: {},
      noResults: false,
    }
  },
  mounted: function () {
    var vm = this
    eventBus.$on('showDetailsEvent',(kwargs) => {
      this.showDetails = kwargs['showDetails']
      this.activeBeach = kwargs['beach']
      if (this.showDetails == false) { this.activeTab = 1 }
    })
  },
  methods: {
    tabChange: function(tab) {
      this.activeTab = tab
      var center = App.map.getCenter()
      setTimeout(function() {
        google.maps.event.trigger(App.map, 'resize')
        App.map.setCenter(center)
      }, 50);
    },
  },
}

</script>
